module.exports = __webpack_public_path__ + "img/telegram.40b27832.svg";